import script from "./PermissionCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionCardModal.vue?vue&type=script&setup=true&lang=js"

import "./PermissionCardModal.vue?vue&type=style&index=0&id=7aa94143&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa94143"]])

export default __exports__